export default __webpack_public_path__ + "static/media/430809e35122bba8c40836246d86d5f4.514ab77a.svg";